import Styles from './Template2.scss';

import Template from './Template2.hbs';
import Wysiwyg from 'views/components/wysiwyg/Wysiwyg';
import DefaultImageElement from 'views/components/taskGroups/sources/source12/templates/elements/image.hbs';
import AnswerExplanation from 'views/components/taskGroups/tasks/answerExplanation/AnswerExplanation';
import GradingTemplate from 'views/components/taskGroups/tasks/template2/Grading.hbs'
import StarRater from 'views/components/starRater/StarRater'
import renderSpecialElements from 'util/RenderSpecialElements';
import Util from 'util/util';
import AuthorPreviewTemplate from './AuthorPreview.hbs'
import CopyToPortfolioView from 'views/pages/activities/copyToPortfolioView/CopyToPortfolioView'
import Textarea from 'views/components/textarea/Textarea.svelte'
import WordCounter from 'views/components/wordCounter/WordCounter.svelte';
import StudentAnswer from './StudentAnswer.svelte'
import SpellingErrorsTag from './SpellingErrorsTag.svelte'
import { autoGrade } from './AutoGradingUtil'

export default class OpenQuestion extends BaseView {

    get events() {
        return {
            'change textarea': 'textareaChanged',
            'input textarea': 'onTextareaUpdate',
            'click .js-textarea-wrapper': 'textareaWrapperClick'
        }
    }

    // Make a mapping for element templates
    get specialElementsConvertList() {
        return {

            // Convertion for HTML element: 'img'
            img: {

                // Default options
                global: {

                    // Set template for the img tag
                    template: DefaultImageElement,
                }
            }
        }
    }

    initialize(options) {

        _.bindAll(this,
            'textareaChanged',
            'showAnswer',
            'hideAnswer',
            'onTextareaUpdate',
            'lockAnswer',
            'unlockAnswer',
            'sendPresentationAnswer',
            'getInputValue',
        );

        this.task_view = options.task_view;

        this.isPresentation = options.isPresentation;

        this.show_answers = options.show_answers

        this.response = this.task_view.response

        this.renderTask()

        this.renderPortfolioPlacer()
    }

    /**
     * renderTask
     *
     * This method will render the template of the task. It will be
     * overwritten with an empty method in /views/components/taskGroups/tasks/Task.js
     * if only the answer view is necessary
     *
     */
    renderTask() {
        this.setElement(Template({
            Styles
        }));

        if (APPLICATION === 'author') {
            return
        }

        // No rich text editors for presentation mode
        if (!this.isPresentation) {

            if (
                (
                    // Check if the input should be formatted
                    this.model.get('task_info_json').formatted === true

                // OR
                ) ||
                (
                    // Check if the user needs equation tools
                    this.model.get('task_info_json').equationTools === true
                )
            ) {

                let wysiwygButtonsPreset = null

                // When the author set the answer to a formatted setting
                if (this.model.get('task_info_json').formatted === true) {
                    wysiwygButtonsPreset = 'taskGroupsTemplate2Formatted'
                }

                // When the author set the answer to enable equation tools
                if (this.model.get('task_info_json').equationTools === true) {
                    if (wysiwygButtonsPreset) {
                        wysiwygButtonsPreset = 'taskGroupsTemplate2All'
                    } else {
                        wysiwygButtonsPreset = 'taskGroupsTemplate2Equations'
                    }
                }

                // Create a wysiwyg view
                this.advancedInput = this.addChildView(new Wysiwyg({
                    content: this.task_view.response.get('json_answer'),
                    autoFocus: false,
                    buttonsPreset: wysiwygButtonsPreset,
                    noAutoCorrect: true,
                    disableEditorOnLoad: this.task_view.showExamAnswers
                }), '.js-text-input')

                // Once the editor has loaded, listen to both input and change events
                // Input: typing or deleting text
                // Change: formatting, pasting, blurring the editor
                this.advancedInput.once('editorLoaded', () => {
                    // When the author allows the display of a word counter
                    if (this.model.get('task_info_json').word_counter === true) {
                        this.wordCounter = this.addSvelteChildView('.js-word-counter-container', WordCounter);
                    }
                    this.advancedInput.on('change', this.onTextareaUpdate)
                })
            }
        }

        if (!this.advancedInput) {
            const isCompact = this.model.get('task_info_json').compact
            if (isCompact) {
                this.el.classList.add(Styles['is-compact'])
            }

            this.addSvelteChildView(
                '.js-text-input',
                Textarea,
                {
                    value: this.task_view.response.get('json_answer'),
                    minLines: isCompact ? 1 : 2,
                    noAutoCorrect: true,
                    noAutoCapitalize: true,
                    disabled: this.task_view.showExamAnswers
                }
            )

            // When the author allows the display of a word counter
            if (this.model.get('task_info_json').word_counter === true) {
                this.wordCounter = this.addSvelteChildView('.js-word-counter-container', WordCounter);
            }
        }

        this.showCollaborativeGrading()
    }

    /**
     * If students have graded each other, show the grading under the task
     *
     * @returns {void}
     */
    showCollaborativeGrading() {

        if (!this.task_view.work_on) {
            return
        }

        const grading = this.task_view.work_on.model.get('StudentGradings')?.find(grading => grading.response_id === this.task_view.response.get('id'))

        if (!grading) {
            return
        }

        this.task_view.appendCollaborativeGrading(
            GradingTemplate({
                Styles,
                feedback: grading.reason,
            })
        )

        this.task_view.addChildView(
            new StarRater({
                amount: 3,
                size: 'medium',
                starred: Math.round(parseFloat(grading.score) * 3),
                isEditable: false,
                identifier: grading.response_id,
            }),
            '.js-star-rater'
        )

    }

    /**
     * updateWordCounter
     *
     * This function checks if there is a wordCounter active. If so, update the count with the user input.
     * Dependent on the plain textarea or the WYSIWYG editor we retrieve the answers in different ways.
     *
     */
    updateWordCounter() {
        if (this.wordCounter) {
            if (this.advancedInput === undefined) {
                this.wordCounter.textString = this.$('textarea').val();
            } else if (this.advancedInput.editor) {
                // We have to get the editor itself from WYSIWYG as we bypass the getContent() function
                this.wordCounter.textString = this.advancedInput.editor.getContent({format: 'text'});
            }
        }
    }

    /**
     * onTextareaUpdate
     *
     * This function is triggered when the user has committed changes to the text area.
     * For the advanced editor, the edits can also be done by the mouse.
     * It will set a timeout that upon expiry will trigger the save method of the template.
     *
     */
    onTextareaUpdate() {
        this.updateWordCounter()

        clearTimeout(this.pendingSaveTimeout);
        this.pendingSaveTimeout = setTimeout(this.textareaChanged, 2000);
    }

    textareaChanged() {

        clearTimeout(this.pendingSaveTimeout);

        if (this.isDestroying === true) {
            return
        }

        // When the user is in a presentation, the answer is saved manually
        if (this.isPresentation) {
            return
        }

        if (this.advancedInput === undefined) {
            this.task_view.saveResponse(this.$('textarea').val());

            if (this.$('textarea').val() === undefined) {
                window.sentry.withScope(scope => {
                    scope.setExtra('pendingSaveTimeout', this.pendingSaveTimeout);
                    scope.setExtra('model', this.model);
                    scope.setExtra('el', this.el);
                    scope.setExtra('$el', this.$el)
                    scope.setExtra('advancedInput', this.advancedInput)

                    window.sentry.captureMessage('Template 2 save response with missing payload json_answer', 'error');
                });
            }
        } else {
            this.task_view.saveResponse(this.advancedInput.getContent());
        }
    }

    textareaWrapperClick() {

        if (
            // Check if the response needs to be scored by the student
            this.task_view.response.get('need-scoring') &&

            // Check if activity type is not presentation
            !this.isPresentation &&

            // Check if activity is not exam
            this.task_view.activityType !== 'exam' &&
            this.task_view.activityType !== 'generated_exam'
        ) {

            // If input is locked, show status
            this.task_view.openScoreFirstMessage();
        }
    }

    lockAnswer() {
        if (this.advancedInput === undefined) {
            this.$('textarea').attr('disabled', true)
        } else {
            this.advancedInput.disableEditor()
        }

        // If there is a send button, this means the answer could
        // have been edited after sending/saving it.
        if (this.task_view.sendButton) {

            // Therefore, put back the last saved instance of the answer in the input.
            this.$('textarea').val(this.savedResponse);
        }

    }

    unlockAnswer() {
        if (this.advancedInput === undefined) {
            // Unlock the textarea for the dom
            this.$('textarea').attr('disabled', false);
        } else if (this.advancedInput.editor) {
            this.advancedInput.enableEditor()
        }

        this.task_view.response.set('correction', true);
    }

    showAnswer() {

        // If a student clicks the show answer button while the timeout is active,
        // save the response first and then show the answer
        if (this.pendingSaveTimeout) {
            this.textareaChanged();
        }

        if (this.model.get('grading_mode') === 'auto') {
            _.defer(() => this.showAnswerWithAutoGrading())
        } else {
            this.showModelAnswer()
        }
    }

    showAuthorAnswer() {
        this.$el.append(AuthorPreviewTemplate({
            Styles,
            content: this.model.get('task_info_json').answer,
        }))
        renderSpecialElements({}, this)
    }

    showModelAnswer(closestModelAnswer = this.model.get('task_info_json').answer) {
        this.modelAnswerView = this.addChildView(
            this.getModelAnswerView(closestModelAnswer, true),
            '.js-correct-answer-container'
        )
    }

    getModelAnswerView(closestModelAnswer, doNotAnimate = false) {
        return new AnswerExplanation({
            isModelAnswer: true,
            title: window.i18n.gettext('Model answer'),
            explanation: closestModelAnswer,
            icon: 'lightbulb',
            doNotAnimate,
            textToSpeechURL: `/tasks/synthesize/${this.model.id}.json?modelAnswer=true&activityId=${this.task_view.activityModel.id}`,
        })
    }

    hideAnswer() {
        this.destroyChildViewsOfType(SpellingErrorsTag)

        if (this.modelAnswerView) {
            this.modelAnswerView.hide();
        }

        this.removeResponseAccuracyStyling()
    }

    getCorrectAnswer() {
        // Render the special elements for corrent answer.
        _.defer(renderSpecialElements, {}, this.task_view, this.task_view.$('.js-correct-answer-holder'));
        return this.model.get('task_info_json').answer;
    }

    getStudentAnswer(responseModel) {

        if (typeof responseModel.get('json_answer') !== 'string') {
            return
        }

        // Catch empty answer
        const givenAnswer = responseModel.get('json_answer').trim()
        if (!givenAnswer.length) {
            return null
        }

        // Validate answer as empty when it does not contain a formula and has zero length after removing
        // all HTML tags and trimming it. This special case for formula has been added due to the way answers
        // containing only a formula are IMG or SVG tags without any textContent, making it seem to
        // Util.stripTags that the answer is empty whilst it is not.
        if (this.model.get('task_info_json').formatted || this.model.get('task_info_json').equationTools) {
            const isEmptyString = !/data\-base64formula=/.test(givenAnswer) && Util.stripTags(givenAnswer).trim().length === 0
            if (isEmptyString) {
                return null
            }
        }

        const holder = new BaseView()
        holder.addSvelteChildView(holder.el, StudentAnswer, {
            givenAnswer,
            model: this.model
        })
        return holder
    }

    /**
     * onClickSendPresentationAnswer
     *
     * Triggered when user sends an answer inside a presentation through the button.
     * It triggers an event in the presentation activity view.
     *
     */
    sendPresentationAnswer() {

        // A student may edit the answer before sending it again to the presentation.
        // When the teacher is checking the answers, the student must see
        // his saved answer on the screen. Therefore save student response in global
        // variable, to put it back in the input when checking answers
        this.savedResponse = this.$('textarea').val().trim();

        // If the saved response is not empty
        if (this.savedResponse) {

            // Save it to DB
            this.task_view.saveResponse(this.savedResponse);

            // Send a trigger to the presentation activity so we can show
            // the teacher an answer has been saved
            this.task_view.work_on.trigger('student-saved-presentation-answer');

            // Lock the answer for student
            this.lockAnswer();
        } else {

            // Show statusmessage saying student can't send an empty answer
            Backbone.View.layout.openStatus(
                window.i18n.gettext('You can\'t send an empty answer'),
                'warning'
            );

            // Reset the view so student can fill an answer again
            this.task_view.onClickEditAnswer();
        }
    }

    /**
     * beforeDestroy
     *
     * Clear time out when this template view gets destroyed to prevent attempts to
     * get the contents of input fields that don't exist anymore after destruction.
     */
    beforeDestroy() {
        if (this.pendingSaveTimeout) {
            this.textareaChanged();
        }
        this.isDestroying = true;
    }

    /**
     * getInputValue
     *
     * get the content form the answer input field and strip tags from it
     *
     * @return {string}  from input content to check if it's correct
     */
    getInputValue() {
        if (this.advancedInput === undefined) {
            return this.$('textarea').val()
        }
        if (this.advancedInput) {
            return Util.stripTags(this.advancedInput.getContent())
        }
    }

    addResponseAccuracyStyling(isCorrect) {
        this.removeResponseAccuracyStyling()
        if (isCorrect) {
            this.$('.js-textarea-wrapper').addClass(Styles['response--correct']);
        } else {
            this.$('.js-textarea-wrapper').addClass(Styles['response--incorrect']);
        }
    }

    removeResponseAccuracyStyling() {
        this.$('.js-textarea-wrapper').removeClass(
            Styles['response--correct']
        ).removeClass(
            Styles['response--incorrect']
        )
    }

    showAnswerWithAutoGrading() {

        // The task has auto grading, but the teacher scored the task
        // Make it green if correct. Otherwise, keep it neutral and show the model answer
        if (this.response.get('scored_by') === 'teacher') {
            if (this.response.get('score') === 1) {
                this.addResponseAccuracyStyling(true)
            } else {
                this.showModelAnswer()
            }
            return
        }

        // Take the latest student answer from the input
        const givenAnswer = this.getInputValue() ?? '';

        // Util does the grading
        const result = autoGrade(this.model, givenAnswer)

        // Make the given answer red or green
        this.addResponseAccuracyStyling(result.isCorrect)

        // For an incorrect answer, also show the model answer
        if (!result.isCorrect) {
            this.showModelAnswer()
        }

        // If the answer is correct, but has spelling errors, show that spelling is incorrect
        // and show the closest model answer
        if (result.isCorrect && result.hasSpellingErrors) {
            this.addSvelteChildView('.js-spelling-errors', SpellingErrorsTag)
            this.showModelAnswer(result.closestCorrectAnswer)
        }
    }

    /**
     * render a "place in portfolio" button if this option has been turned.
     * the button will open a modal to place the open question in a
     * student's portfolio
     *
     * @returns {void}
     */
    renderPortfolioPlacer() {

        if (!this.model.get('task_info_json').canBePlacedInPortfolio) {
            return
        }

        this.portfolioPlacerView = this.addChildView(
            new CopyToPortfolioView({
                model: this.model,
                saveSource: async (portfolioProject) => {

                    let text = ''

                    // Use the plain text content of introduction (without HTML) because we need to wrap it in
                    // a p and strong tag. Use the textContent property to make it safe.
                    const introduction = jQuery(this.model.get('introduction')).text().trim()
                    if (introduction) {
                        const p = document.createElement('p')
                        const strong = document.createElement('strong')
                        strong.textContent = introduction
                        p.appendChild(strong)
                        text += p.outerHTML
                    }

                    if (this.advancedInput) {
                        text += this.advancedInput.getContent()
                    } else {
                        // Make the content of textarea safe via textContent and then replace newlines with <br>
                        const p = document.createElement('p')
                        p.textContent = this.$('textarea').val()
                        p.innerHTML = p.innerHTML.replace(/\r\n|\r|\n/g, '<br>')
                        text += p.outerHTML
                    }

                    await portfolioProject.get('elements').create({
                        project_id: portfolioProject.get('id'),
                        template_id: 12,
                        element_type: 'source',
                        sequence: portfolioProject.get('elements').length,
                        title: '',
                        source: {
                            text,
                        },
                    })

                    Backbone.View.Components.modal.close()

                    Backbone.View.layout.openStatus(
                        window.i18n.sprintf(
                            window.i18n.gettext('Task copied to portfolio "%s"'),
                            portfolioProject.get('title')
                        ),
                        'success',
                        {
                            hasArrowIcon: true,
                            elementCallback: () => {
                                Backbone.history.navigate(
                                    `/portfolio/project/${portfolioProject.id}`,
                                    { trigger: true }
                                )
                            }
                        }
                    )
                }
            }),
            '.js-add-to-portfolio-holder'
        )
    }
}
